import { audiencePurchasesInitialFormValues } from '@occc-app/routes/Audience/components/Purchases/constants';
import { PurchaseFormInitialValues } from '@occc-app/routes/Audience/components/Purchases/types';

import { convertDateConditionToInitialFormValues } from './convertDateConditionToInitialFormValues';
import { mapTypenameToMemberPurchasedOperator } from './mapTypenameToMemberPurchasedOperator';
import { useGetAudienceWithDataById } from '../../../../../dataAccessLayer/audience/useGetAudienceWithDataById';

export const convertPurchasesToFormInitialValues = (
  purchases: NonNullable<
    ReturnType<typeof useGetAudienceWithDataById>['data']
  >['targetingAttributes']['purchases'],
): PurchaseFormInitialValues[] => {
  return purchases?.length
    ? purchases.map(
        ({
          excludeThreshold,
          __typename,
          threshold,
          locations,
          locationGroups,
          productGroups,
          productGroupIds,
          purchasedLocationUuids,
          purchasedLocationGroupUuids,
          countProductsBy,
          ...dateCondition
        }): PurchaseFormInitialValues => {
          const { timePeriodType, fixedMonth, fixedWindow, timeWindow } =
            convertDateConditionToInitialFormValues({
              targetYear: dateCondition.targetYear,
              targetMonth: dateCondition.targetMonth,
              startDate: dateCondition.startDate,
              relativeMonthsBack: dateCondition.relativeMonthsBack,
              endDate: dateCondition.endDate,
              timeWindow: dateCondition.timeWindow,
            });

          return {
            timePeriodType,
            fixedMonth,
            fixedWindow,
            timeWindow,
            type: mapTypenameToMemberPurchasedOperator(__typename, excludeThreshold),
            threshold,
            locations,
            locationGroups,
            productGroups,
            purchasedLocationUuids,
            purchasedLocationGroupUuids,
            countProductsBy: countProductsBy || null,
          };
        },
      )
    : [{ ...audiencePurchasesInitialFormValues }];
};
